var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 12,
    y2: 492.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00efd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 167,
    x2: 167,
    y1: 12,
    y2: 492.337,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 239.5,
    x2: 239.5,
    y1: 12,
    y2: 492.337,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 323.718,
    x2: 323.718,
    y1: 12,
    y2: 492.337,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M443.453,209.7a12.085,12.085,0,0,1-1.964-7.265l2.045-37.139A28,28,0,0,0,428.2,138.765l-33-16.668a11.917,11.917,0,0,1-5.3-5.3l-16.669-33A27.992,27.992,0,0,0,346.7,68.466l-37.14,2.045a12.113,12.113,0,0,1-7.264-1.964L271.413,48.182a27.967,27.967,0,0,0-30.825,0L209.7,68.547a12.082,12.082,0,0,1-7.265,1.964L165.3,68.466A28.017,28.017,0,0,0,138.766,83.8l-16.669,33a11.917,11.917,0,0,1-5.3,5.3l-33,16.668A28,28,0,0,0,68.466,165.3l2.045,37.137a12.088,12.088,0,0,1-1.963,7.265L48.182,240.587a27.971,27.971,0,0,0,0,30.826L68.547,302.3a12.085,12.085,0,0,1,1.964,7.265L68.466,346.7A28,28,0,0,0,83.8,373.235l33,16.668a11.917,11.917,0,0,1,5.3,5.3l16.669,33a28,28,0,0,0,26.53,15.333l37.14-2.045a12.1,12.1,0,0,1,7.264,1.964l30.887,20.365a27.968,27.968,0,0,0,30.825,0L302.3,443.453a12.087,12.087,0,0,1,7.265-1.964l37.139,2.045a27.987,27.987,0,0,0,26.53-15.333l16.669-33a11.917,11.917,0,0,1,5.3-5.3l33-16.668A28,28,0,0,0,443.534,346.7l-2.045-37.137a12.088,12.088,0,0,1,1.963-7.265l20.366-30.888a27.971,27.971,0,0,0,0-30.826Zm7.008,52.905-20.367,30.889a28.191,28.191,0,0,0-4.581,16.951l2.045,37.138a12,12,0,0,1-6.572,11.371l-33,16.668a27.807,27.807,0,0,0-12.368,12.367l-16.669,33a11.972,11.972,0,0,1-11.37,6.571l-37.139-2.044a28.17,28.17,0,0,0-16.951,4.581L262.6,450.46a11.982,11.982,0,0,1-13.209,0L218.507,430.1a28.206,28.206,0,0,0-15.444-4.623q-.753,0-1.507.042l-37.139,2.044a11.982,11.982,0,0,1-11.37-6.571l-16.669-33a27.807,27.807,0,0,0-12.367-12.368l-33-16.668a12,12,0,0,1-6.572-11.371l2.045-37.139a28.188,28.188,0,0,0-4.582-16.951L61.539,262.606a11.989,11.989,0,0,1,0-13.211l20.367-30.889a28.191,28.191,0,0,0,4.581-16.951l-2.045-37.138a12,12,0,0,1,6.572-11.371l33-16.668a27.807,27.807,0,0,0,12.368-12.367l16.669-33a11.99,11.99,0,0,1,11.37-6.571l37.139,2.044a28.207,28.207,0,0,0,16.951-4.581L249.4,61.54a11.981,11.981,0,0,1,13.208,0h0l30.888,20.365a28.173,28.173,0,0,0,16.951,4.581l37.139-2.044a11.983,11.983,0,0,1,11.37,6.571l16.669,33a27.807,27.807,0,0,0,12.367,12.368l33,16.668a12,12,0,0,1,6.572,11.371l-2.045,37.139a28.188,28.188,0,0,0,4.582,16.951l20.366,30.887A11.989,11.989,0,0,1,450.461,262.605Z",
    "data-name": "<Compound Path>"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M186,216.106c-4.078,0-9,1.447-9,5.524v34.317l-16.437-31.234c-4.133-7.94-6.491-8.607-12.731-8.607-4.4,0-8.832,1.741-8.832,5.631v67.884c0,3.87,4.743,5.632,9,5.632s9-1.762,9-5.632v-34.4L176.174,290.5c2.273,4.187,6.323,4.751,9.864,4.751,4.256,0,8.962-1.762,8.962-5.632V221.63C195,217.553,190.077,216.106,186,216.106Z",
    "data-name": "<Path>"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M259.475,232c3.253,0,5.524-3.469,5.524-8.107,0-3.814-1.708-7.893-5.524-7.893H221.416c-3.742,0-7.416,1.868-7.416,5.737v67.884c0,3.87,3.674,5.379,7.416,5.379h38.059c3.816,0,5.524-3.579,5.524-7.393,0-4.638-2.271-7.607-5.524-7.607H231V263h15.859c3.8,0,5.525-3.615,5.525-6.893,0-3.489-1.9-7.107-5.525-7.107H231V232Z",
    "data-name": "<Path>"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M361.776,216.106c-3.118,0-5.187,1.229-5.825,3.458L340.238,272.6l-8.013-34.289c-.73-3.281-4.92-4.775-8.506-4.775s-7.778,1.494-8.506,4.77L307.2,272.6l-15.712-53.026c-.637-2.233-2.707-3.463-5.826-3.463-5.117,0-11.3,3.18-11.3,7.128a5.226,5.226,0,0,0,.24,1.544l21.272,65.207c1.37,4.362,7.045,5.909,11.488,5.909,4.941,0,10.346-1.839,11.285-5.952l5.072-23.11,5.071,23.115c.939,4.108,6.345,5.947,11.285,5.947,5.747,0,10.255-2.314,11.484-5.9l21.276-65.217a5.28,5.28,0,0,0,.239-1.547C373.074,219.286,366.894,216.106,361.776,216.106Z",
    "data-name": "<Path>"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.263548583ceed603a4de69156d20f83a.svg";
export { ForwardRef as ReactComponent };